import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchTranslationKeysInput, SearchTranslationKeysOutput, PublishChangesInput, RevertChangesInput, PublishAllChangesInput, RevertAllChangesInput, GetLanguageFilesInput, GetLanguageFilesOutput } from '../../PathItems'

export class SearchTranslationKeys extends RequestOperation<SearchTranslationKeysInput,SearchTranslationKeysOutput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.SearchTranslationKeys",
      "SEARCH",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class PatchTranslation extends MessageOperation<TranslationKeyPair> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PatchTranslation",
      "PATCH",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateTranslationKey extends MessageOperation<TranslationKeyPair> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.CreateTranslationKey",
      "CREATE",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetLanguages extends RequestOperation<object,Language[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.GetLanguages",
      "GET",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteTranslationKey extends MessageOperation<string> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.DeleteTranslationKey",
      "DELETE",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class PatchManyTranslations extends MessageOperation<MultipleTranslationKeyPairs> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PatchManyTranslations",
      "PATCH",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateManyTranslationKeys extends MessageOperation<MultipleTranslationKeyPairs> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.CreateManyTranslationKeys",
      "CREATE",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class PublishChanges extends MessageOperation<PublishChangesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PublishChanges",
      "PATCH",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class RevertChanges extends MessageOperation<RevertChangesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.RevertChanges",
      "PATCH",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class PublishAllChanges extends MessageOperation<PublishAllChangesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.PublishAllChanges",
      "PATCH",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class RevertAllChanges extends MessageOperation<RevertAllChangesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.RevertAllChanges",
      "PATCH",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetLanguageFiles extends RequestOperation<GetLanguageFilesInput,GetLanguageFilesOutput[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Translations.GetLanguageFiles",
      "GET",
      [],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type SearchTranslationKeysOutputKeys = {
  key: string
  value1: string
  value2: string
  lastPublishedAt?: Date | undefined
  publishedValue2?: string | undefined
  publishedValue1?: string | undefined
  /**
   * Valid values: draft, published
   */
  stateType: string
}

export type TranslationKeyPair = {
  key: string
  language1Value: LanguageValue
  language2Value: LanguageValue
}

export type LanguageValue = {
  languageId: string
  value: string
}

export type Language = {
  id: string
  name: string
}

export type MultipleTranslationKeyPairs = {
  language1: string
  language2: string
  keys: Keys[]
}

export type Keys = {
  key: string
  value1: string
  value2: string
}

